export default __webpack_public_path__ + "static/media/project-mention.af3fcf35.svg";